module.exports = __webpack_public_path__ + "img/marker-nodisc.7abebe51.png";